/** crd0102
 */

export interface issueCardPreInqInfo {
    /** 전체상품코드
     * @type {string}
     */
    allPdcd: string

    /** 상품라인코드
     * @type {string}
     */
    pdlnCd: string

    /** 상품그룹코드
     * @type {string}
     */
    pdgrCd: string

    /** 상품템플릿코드
     * @type {string}
     */
    pdtmCd: string

    /** 상품코드
     * @type {string}
     */
    pdcd: string

    /** 비대면채널제공상품명
     * @type {string}
     */
    nfchOfrPdm: string

    /** 비대면채널상품분류그룹코드
     * @type {string}
     */
    nfchPrcfGrpCd: string

    /** 비대면채널상품분류그룹코드명
     * @type {string}
     */
    nfchPrcfGrpCdNm: string

    /** 심의기간시작년월일(yyyy.MM.dd)
     * @type {string}
     */
    dlbtTrmSttgYmd: string

    /** 심의기간완료년월일(yyyy.MM.dd)
     * @type {string}
     */
    dlbtTrmFnsgYmd: string

    /** 비대면채널채팅상담여부
     * @type {string}
     */
    nfchChttCnslYn: string

    /** 비대면채널영상상담여부
     * @type {string}
     */
    nfchPictCnslYn: string

    /** 준법지원부심의내용
     * @type {string}
     */
    lsdpDlbtCon: string

    /** 신용카드제휴코드
     * @type {string}
     */
    ccalCd: string

    /** 상품정보링크URL주소
     * @type {string}
     */
    pdifLinkUrlAdr: string

    /** 가입채널정보내용
     * @type {string}
     */
    jnngChnlInfoCon: string

    /** 상품장바구니등록건수
     * @type {number}
     */
    pdfShbkRgsnNbi: number

    /** 후불교통카드기능여부
     * @type {string}
     */
    ftpmTrcdFuncYn: string

    /** 학생증카드여부
     * @type {string}
     */
    sccYn: string

    /** 국제학생증카드타입(N/ISIC/IYTC)
     * @type {string}
     */
    innnSccType: string

    /** 카드발급구분코드(코드: CDIS_DCD)
     * @type {string}
     */
    cdisDcd: string

    /** 후불교통카드여부
     * @type {string}
     */
    ftpmTrcdYn: string

    /** 체크카드보유여부
     * @type {string}
     */
    chcrHoldYn: string

    /** 신용카드보유여부
     * @type {string}
     */
    crdHoldYn: string

    /** 중복여부
     * @type {string}
     */
    dpltYn: string

    /** 청구서발송방법코드(코드: DMSH_SNDG_MCD)
     * @type {string}
     */
    dmshSndgMcd: string

    /** 발송명세서명
     * @type {string}
     */
    sndgDlstNm: string

    /** 대금청구지구분코드
     * @type {string}
     */
    mnpbAsarDcd: string

    /** 탈회후재입회여부
     * @type {string}
     */
    wfafReAdmbYn: string

    /** 회원명
     * @type {string}
     */
    mmbrNm: string

    /** 회원영문명
     * @type {string}
     */
    mmbrEnsnNm: string

    /** 외국인여부
     * @type {string}
     */
    frgnYn: string

    /** 국가코드
     * @type {string}
     */
    ntcd: string

    /** 성별구분코드
     * @type {string}
     */
    gndrDcd: string

    /** 직장명
     * @type {string}
     */
    wrplNm: string

    /** 부서명
     * @type {string}
     */
    dvm: string

    /** 직위명
     * @type {string}
     */
    jtm: string

    /** 전산고객번호
     * @type {number}
     */
    edpsCsn: number

    /** 고객계좌식별번호
     * @type {string}
     */
    csacIdntNo: string

    /** 모집경로코드
     * @type {string}
     */
    enlsPathCd: string

    /** 모집유형코드
     * @type {string}
     */
    enlsTcd: string

    /** 이메일주소
     * @type {string}
     */
    ead: string

    /** 심사상태코드
     * @type {string}
     */
    exntScd: string

    /** 결제일
     * @type {string}
     */
    stlmDd: string

    /** 결제은행코드
     * @type {string}
     */
    stlmBncd: string

    /** 결제은행코드명
     * @type {string}
     */
    stlmBncdNm: string

    /** 결제계좌번호
     * @type {string}
     */
    stlmAcn: string

    /** 사업부제코드
     * @type {string}
     */
    bdsCd: string

    /** 고객관리팀코드
     * @type {string}
     */
    csmnTeamCd: string

    /** 신용정보이용동의여부
     * @type {string}
     */
    crifUtlCosnYn: string

    /** 고유식별정보이용동의여부
     * @type {string}
     */
    orriUtlCosnYn: string

    /** 신용정보제공동의여부
     * @type {string}
     */
    crdtInofrCosnYn: string

    /** 고유식별정보제공동의여부
     * @type {string}
     */
    orriOfrCosnYn: string

    /** 신용카드전화권유동의여부
     * @type {string}
     */
    crdTelSlcsYn: string

    /** 신용카드SMS권유동의여부
     * @type {string}
     */
    crdSmsSlcsYn: string

    /** 신용카드서면권유동의여부
     * @type {string}
     */
    crdInwrSlcsYn: string

    /** 신용카드이메일권유동의여부
     * @type {string}
     */
    crdEmlSlcsYn: string

    /** 상품이용권유동의여부
     * @type {string}
     */
    pdfUtlSlcsYn: string

    /** 상품부수서비스안내동의여부
     * @type {string}
     */
    pdfNmcpSrgnCosnYn: string

    /** 부정사용방지정보제공동의여부
     * @type {string}
     */
    ilusPrvnInfoOffsYn: string

    /** 관리부점코드
     * @type {string}
     */
    mngmBrcd: string

    /** SMS휴대폰서비스번호
     * @type {string}
     */
    smsClphSvcNo: string

    /** SMS휴대폰국번호
     * @type {string}
     */
    smsClphTon: string

    /** SMS휴대폰개별번호
     * @type {string}
     */
    smsClphIncsNo: string

    /** 자택우편번호
     * @type {string}
     */
    oohZpcd: string

    /** 자택우편번호기본주소
     * @type {string}
     */
    oohZpcdBscAdr: string

    /** 자택우편번호상세주소
     * @type {string}
     */
    oohZpcdDtlAdr: string

    /** 자택도로명주소구분코드(코드: OOH_RDND_DCD)
     * @type {string}
     */
    oohRdndDcd: string

    /** 자택도로명기본주소
     * @type {string}
     */
    oohRdnmBscAdr: string

    /** 자택도로명상세주소
     * @type {string}
     */
    oohRdnmDtlAdr: string

    /** 자택건물관리번호
     * @type {string}
     */
    oohBldnMngmNo: string

    /** 자택지역번호
     * @type {string}
     */
    oohLln: string

    /** 자택국번호
     * @type {string}
     */
    oohTon: string

    /** 자택개별번호
     * @type {string}
     */
    oohIncsNo: string

    /** 직장우편번호
     * @type {string}
     */
    wrplZpcd: string

    /** 직장우편번호기본주소
     * @type {string}
     */
    wrplZpcdBscAdr: string

    /** 직장우편번호상세주소
     * @type {string}
     */
    wrplZpcdDtlAdr: string

    /** 직장도로명주소구분코드(코드:WRPL_RDND_DCD)
     * @type {string}
     */
    wrplRdndDcd: string

    /** 직장도로명기본주소
     * @type {string}
     */
    wrplRdnmBscAdr: string

    /** 직장도로명상세주소
     * @type {string}
     */
    wrplRdnmDtlAdr: string

    /** 직장건물관리번호
     * @type {string}
     */
    wrplBldnMngmNo: string

    /** 직장지역번호
     * @type {string}
     */
    wrplLln: string

    /** 직장국번호
     * @type {string}
     */
    wrplTon: string

    /** 직장개별번호
     * @type {string}
     */
    wrplIncsNo: string

    /** 팩스지역번호
     * @type {string}
     */
    faxLln: string

    /** 팩스국번호
     * @type {string}
     */
    faxTon: string

    /** 팩스개별번호
     * @type {string}
     */
    faxIncsNo: string

    /** 별도청구지우편번호
     * @type {string}
     */
    spaeZpcd: string

    /** 별도청구지우편번호기본주소
     * @type {string}
     */
    spaeZpcdBscAdr: string

    /** 별도청구지우편번호상세주소
     * @type {string}
     */
    spaeZpcdDtlAdr: string

    /** 별도청구지도로명주소구분코드
     * @type {string}
     */
    spaeRdndDcd: string

    /** 별도청구지도로명기본주소
     * @type {string}
     */
    spaeRdnmBscAdr: string

    /** 별도청구지도로명상세주소
     * @type {string}
     */
    spaeRdnmDtlAdr: string

    /** 별도청구지건물관리번호
     * @type {string}
     */
    spaeBldnMngmNo: string

    /** 별도청구지전화지역번호
     * @type {string}
     */
    spaeTelLln: string

    /** 별도청구지전화국번호
     * @type {string}
     */
    spaeTelTon: string

    /** 별도청구지전화개별번호
     * @type {string}
     */
    spaeTelIncsNo: string

    /** 오류응답서비스ID
     * @type {string}
     */
    erorRspnSvcId: string

    /** 에러대상메시지내용
     * @type {string}
     */
    errTgtMsgCon: string

    /** 후불교통카드여부
     * @type {string}
     */
    ftpmTrcdYn2: string

    /** 해외사용가능여부
     * @type {string}
     */
    ovrsUseAblYn2: string

    /** 후불교통카드여부
     * @type {string}
     */
    ftpmTrcdYn3: string

	/** 수수료수납여부
	 * @type {string}
	 */
	feeRcptYn: string
	
	/** 출금의뢰금액
	 * @type {number}
	 */
	drotReqsAmt: number
	
	/** 항공사카드여부
	 * @type {string}
	 */
	arliCardYn: string
	
    /** PdfDtlList1[]
     * @type {PdfDtlList1[]}
     */
    pdfDtlList1: PdfDtlList1[]

    /** PdfDtlList2[]
     * @type {PdfDtlList2[]}
     */
    pdfDtlList2: PdfDtlList2[]

    /** PdfAddList1[]
     * @type {PdfAddList1[]}
     */
    pdfAddList1: PdfAddList1[]

    /** PdfAddList2[]
     * @type {PdfAddList2[]}
     */
    pdfAddList2: PdfAddList2[]

    /** PdfLnkList[]
     * @type {PdfLnkList[]}
     */
    pdfLnkList: PdfLnkList[]

    /** RltdPdfList[]
     * @type {RltdPdfList[]}
     */
    rltdPdfList: RltdPdfList[]

    /** PdtmInfoList[]
     * @type {PdtmInfoList[]}
     */
    pdtmInfoList: PdtmInfoList[]
}
export interface PdfDtlList1 {
    /** 보기정렬순서
     * @type {number}
     */
    lkngLnpSqc: number

    /** 비대면채널상품게시정보종류코드
     * @type {string}
     */
    nfchPdfBltInfoKcd: string

    /** 비대면채널상품게시정보대분류코드
     * @type {string}
     */
    nfchPdfBltInfoLrcd: string

    /** 비대면채널상품게시정보대분류코드명
     * @type {string}
     */
    nfchPdfBltInfoLrcdNm: string

    /** 비대면채널상품게시정보중분류코드
     * @type {string}
     */
    nfchPdfBltInfoMdvcd: string

    /** 비대면채널상품게시정보중분류코드명
     * @type {string}
     */
    nfchPdfBltInfoMdvcdNm: string

    /** 비대면채널상품안내정보일련번호
     * @type {number}
     */
    nfchPdgdInfoSrn: number

    /** 비대면채널조건값데이터내용
     * @type {string}
     */
    nfchCnvlDataCon: string

    /** 조건값데이터내용
     * @type {string}
     */
    cnvlDataCon: string
}
export interface PdfDtlList2 {
    /** 보기정렬순서
     * @type {number}
     */
    lkngLnpSqc: number

    /** 비대면채널상품게시정보종류코드
     * @type {string}
     */
    nfchPdfBltInfoKcd: string

    /** 비대면채널상품게시정보대분류코드
     * @type {string}
     */
    nfchPdfBltInfoLrcd: string

    /** 비대면채널상품게시정보대분류코드명
     * @type {string}
     */
    nfchPdfBltInfoLrcdNm: string

    /** 비대면채널상품게시정보중분류코드
     * @type {string}
     */
    nfchPdfBltInfoMdvcd: string

    /** 비대면채널상품게시정보중분류코드명
     * @type {string}
     */
    nfchPdfBltInfoMdvcdNm: string

    /** 비대면채널상품안내정보일련번호
     * @type {number}
     */
    nfchPdgdInfoSrn: number

    /** 비대면채널상품안내정보상세내용
     * @type {string}
     */
    nfchPdgdInfoDtlCon: string

    /** 비대면채널상품안내정보HTML사용여부
     * @type {string}
     */
    nfchPdgdInfoHtmlUseYn: string
}
export interface PdfAddList1 {
    /** 비대면채널상품부가정보분류코드
     * @type {string}
     */
    nfchPdfAddifClcd: string

    /** 비대면채널상품부가정보일련번호
     * @type {number}
     */
    nfchPdfAddifSrn: number

    /** 비대면채널상품부가정보제목명
     * @type {string}
     */
    nfchPdfAddifTtlNm: string

    /** 비대면채널상품부가정보실제파일명
     * @type {string}
     */
    nfchPdfAddifReflNm: string

    /** 비대면채널상품부가정보URL주소
     * @type {string}
     */
    nfchPdfAddifUrlAdr: string

    /** 비대면채널상품부가정보연계팝업여부
     * @type {string}
     */
    nfchPdfAddifLnkPpupYn: string

    /** 이벤트시작년월일
     * @type {string}
     */
    evntSttgYmd: string

    /** 이벤트종료년월일
     * @type {string}
     */
    evntFnshYmd: string

    /** 시작시각
     * @type {string}
     */
    sttgHms: string

    /** 종료시각
     * @type {string}
     */
    fnshHms: string
}
export interface PdfAddList2 {
    /** 비대면채널상품부가정보분류코드
     * @type {string}
     */
    nfchPdfAddifClcd: string

    /** 비대면채널상품부가정보일련번호
     * @type {number}
     */
    nfchPdfAddifSrn: number

    /** 비대면채널상품부가정보제목명
     * @type {string}
     */
    nfchPdfAddifTtlNm: string

    /** 비대면채널상품부가정보실제파일명
     * @type {string}
     */
    nfchPdfAddifReflNm: string

    /** 비대면채널상품부가정보URL주소
     * @type {string}
     */
    nfchPdfAddifUrlAdr: string

    /** 비대면채널상품부가정보연계팝업여부
     * @type {string}
     */
    nfchPdfAddifLnkPpupYn: string

    /** 이벤트시작년월일
     * @type {string}
     */
    evntSttgYmd: string

    /** 이벤트종료년월일
     * @type {string}
     */
    evntFnshYmd: string

    /** 시작시각
     * @type {string}
     */
    sttgHms: string

    /** 종료시각
     * @type {string}
     */
    fnshHms: string
}
export interface PdfLnkList {
    /** 상품라인코드
     * @type {string}
     */
    pdlnCd: string

    /** 상품그룹코드
     * @type {string}
     */
    pdgrCd: string

    /** 상품템플릿코드
     * @type {string}
     */
    pdtmCd: string

    /** 상품코드
     * @type {string}
     */
    pdcd: string

    /** 상품내부코드
     * @type {string}
     */
    pdfIntcd: string
}
export interface RltdPdfList {
    /** 상품라인코드
     * @type {string}
     */
    pdlnCd: string

    /** 상품그룹코드
     * @type {string}
     */
    pdgrCd: string

    /** 상품템플릿코드
     * @type {string}
     */
    pdtmCd: string

    /** 상품코드
     * @type {string}
     */
    pdcd: string

    /** 상품내부코드
     * @type {string}
     */
    pdfIntcd: string

    /** 전행서비스코드
     * @type {string}
     */
    whbnVcd: string

    /** 비대면채널제공상품명
     * @type {string}
     */
    nfchOfrPdm: string

    /** 상품몰구분코드
     * @type {string}
     */
    pdmlDcd: string
}
export interface PdtmInfoList {
    /** 비대면채널상품템플릿ID
     * @type {string}
     */
    nfchPdtmId: string

    /** 비대면채널상품템플릿유형코드
     * @type {string}
     */
    nfchPdtmTcd: string

    /** 비대면채널상품템플릿유형명
     * @type {string}
     */
    nfchPdtmPtrnNm: string

    /** 비대면채널상품템플릿제목명
     * @type {string}
     */
    nfchPdtmTtlNm: string

    /** 비대면채널상품템플릿내용
     * @type {string}
     */
    nfchPdtmCon: string

    /** 비대면채널상품템플릿HTML사용여부
     * @type {string}
     */
    nfchPdtmHtmlUseYn: string
}

export const initialState: issueCardPreInqInfo = {
    /** 전체상품코드
     * @type {string}
     */
    allPdcd: '',

    /** 상품라인코드
     * @type {string}
     */
    pdlnCd: '',

    /** 상품그룹코드
     * @type {string}
     */
    pdgrCd: '',

    /** 상품템플릿코드
     * @type {string}
     */
    pdtmCd: '',
    /** 상품코드
     * @type {string}
     */
    pdcd: '',

    /** 비대면채널제공상품명
     * @type {string}
     */
    nfchOfrPdm: '',

    /** 비대면채널상품분류그룹코드
     * @type {string}
     */
    nfchPrcfGrpCd: '',

    /** 비대면채널상품분류그룹코드명
     * @type {string}
     */
    nfchPrcfGrpCdNm: '',

    /** 심의기간시작년월일(yyyy.MM.dd)
     * @type {string}
     */
    dlbtTrmSttgYmd: '',
    /** 심의기간완료년월일(yyyy.MM.dd)
     * @type {string}
     */
    dlbtTrmFnsgYmd: '',

    /** 비대면채널채팅상담여부
     * @type {string}
     */
    nfchChttCnslYn: '',

    /** 비대면채널영상상담여부
     * @type {string}
     */
    nfchPictCnslYn: '',

    /** 준법지원부심의내용
     * @type {string}
     */
    lsdpDlbtCon: '',

    /** 신용카드제휴코드
     * @type {string}
     */
    ccalCd: '',

    /** 상품정보링크URL주소
     * @type {string}
     */
    pdifLinkUrlAdr: '',

    /** 가입채널정보내용
     * @type {string}
     */
    jnngChnlInfoCon: '',

    /** 상품장바구니등록건수
     * @type {number}
     */
    pdfShbkRgsnNbi: 0,

    /** 후불교통카드기능여부
     * @type {string}
     */
    ftpmTrcdFuncYn: '',

    /** 카드발급구분코드("1" 신규발급 , "2" 추가발급)
     * @type {string}
     */
    cdisDcd: '',

    /** 후불교통카드여부
     * @type {string}
     */
    ftpmTrcdYn: '',

    /** 체크카드보유여부
     * @type {string}
     */
    chcrHoldYn: '',

    /** 신용카드보유여부
     * @type {string}
     */
    crdHoldYn: '',

    /** 중복여부
     * @type {string}
     */
    dpltYn: '',

    /** 청구서발송방법코드(코드: DMSH_SNDG_MCD)
     * @type {string}
     */
    dmshSndgMcd: '',

    /** 발송명세서명
     * @type {string}
     */
    sndgDlstNm: '',

    /** 대금청구지구분코드
     * @type {string}
     */
    mnpbAsarDcd: '',

    /** 탈회후재입회여부
     * @type {string}
     */
    wfafReAdmbYn: '',

    /** 회원명
     * @type {string}
     */
    mmbrNm: '',

    /** 회원영문명
     * @type {string}
     */
    mmbrEnsnNm: '',

    /** 외국인여부
     * @type {string}
     */
    frgnYn: '',

    /** 국가코드
     * @type {string}
     */
    ntcd: '',

    /** 성별구분코드
     * @type {string}
     */
    gndrDcd: '',

    /** 직장명
     * @type {string}
     */
    wrplNm: '',

    /** 부서명
     * @type {string}
     */
    dvm: '',

    /** 직위명
     * @type {string}
     */
    jtm: '',

    /** 전산고객번호
     * @type {number}
     */
    edpsCsn: 0,

    /** 고객계좌식별번호
     * @type {string}
     */
    csacIdntNo: '',

    /** 모집경로코드
     * @type {string}
     */
    enlsPathCd: '',
    /** 모집유형코드
     * @type {string}
     */
    enlsTcd: '',

    /** 이메일주소
     * @type {string}
     */
    ead: '',

    /** 심사상태코드
     * @type {string}
     */
    exntScd: '',

    /** 결제일
     * @type {string}
     */
    stlmDd: '',

    /** 결제은행코드
     * @type {string}
     */
    stlmBncd: '',

    /** 결제은행코드명
     * @type {string}
     */
    stlmBncdNm: '',

    /** 결제계좌번호
     * @type {string}
     */
    stlmAcn: '',

    /** 사업부제코드
     * @type {string}
     */
    bdsCd: '',

    /** 고객관리팀코드
     * @type {string}
     */
    csmnTeamCd: '',

    /** 신용정보이용동의여부
     * @type {string}
     */
    crifUtlCosnYn: '',
    /** 고유식별정보이용동의여부
     * @type {string}
     */
    orriUtlCosnYn: '',

    /** 신용정보제공동의여부
     * @type {string}
     */
    crdtInofrCosnYn: '',

    /** 고유식별정보제공동의여부
     * @type {string}
     */
    orriOfrCosnYn: '',

    /** 신용카드전화권유동의여부
     * @type {string}
     */
    crdTelSlcsYn: '',

    /** 신용카드SMS권유동의여부
     * @type {string}
     */
    crdSmsSlcsYn: '',

    /** 신용카드서면권유동의여부
     * @type {string}
     */
    crdInwrSlcsYn: '',

    /** 신용카드이메일권유동의여부
     * @type {string}
     */
    crdEmlSlcsYn: '',

    /** 상품이용권유동의여부
     * @type {string}
     */
    pdfUtlSlcsYn: '',

    /** 상품부수서비스안내동의여부
     * @type {string}
     */
    pdfNmcpSrgnCosnYn: '',

    /** 부정사용방지정보제공동의여부
     * @type {string}
     */
    ilusPrvnInfoOffsYn: '',

    /** 관리부점코드
     * @type {string}
     */
    mngmBrcd: '',

    /** SMS휴대폰서비스번호
     * @type {string}
     */
    smsClphSvcNo: '',

    /** SMS휴대폰국번호
     * @type {string}
     */
    smsClphTon: '',

    /** SMS휴대폰개별번호
     * @type {string}
     */
    smsClphIncsNo: '',

    /** 자택우편번호
     * @type {string}
     */
    oohZpcd: '',

    /** 자택우편번호기본주소
     * @type {string}
     */
    oohZpcdBscAdr: '',

    /** 자택우편번호상세주소
     * @type {string}
     */
    oohZpcdDtlAdr: '',

    /** 자택도로명주소구분코드(코드: OOH_RDND_DCD)
     * @type {string}
     */
    oohRdndDcd: '',

    /** 자택도로명기본주소
     * @type {string}
     */
    oohRdnmBscAdr: '',

    /** 자택도로명상세주소
     * @type {string}
     */
    oohRdnmDtlAdr: '',

    /** 자택건물관리번호
     * @type {string}
     */
    oohBldnMngmNo: '',

    /** 자택지역번호
     * @type {string}
     */
    oohLln: '',

    /** 자택국번호
     * @type {string}
     */
    oohTon: '',

    /** 자택개별번호
     * @type {string}
     */
    oohIncsNo: '',

    /** 직장우편번호
     * @type {string}
     */
    wrplZpcd: '',

    /** 직장우편번호기본주소
     * @type {string}
     */
    wrplZpcdBscAdr: '',

    /** 직장우편번호상세주소
     * @type {string}
     */
    wrplZpcdDtlAdr: '',

    /** 직장도로명주소구분코드(코드:WRPL_RDND_DCD)
     * @type {string}
     */
    wrplRdndDcd: '',

    /** 직장도로명기본주소
     * @type {string}
     */
    wrplRdnmBscAdr: '',

    /** 직장도로명상세주소
     * @type {string}
     */
    wrplRdnmDtlAdr: '',

    /** 직장건물관리번호
     * @type {string}
     */
    wrplBldnMngmNo: '',

    /** 직장지역번호
     * @type {string}
     */
    wrplLln: '',

    /** 직장국번호
     * @type {string}
     */
    wrplTon: '',

    /** 직장개별번호
     * @type {string}
     */
    wrplIncsNo: '',

    /** 팩스지역번호
     * @type {string}
     */
    faxLln: '',

    /** 팩스국번호
     * @type {string}
     */
    faxTon: '',
    /** 팩스개별번호
     * @type {string}
     */
    faxIncsNo: '',

    /** 별도청구지우편번호
     * @type {string}
     */
    spaeZpcd: '',

    /** 별도청구지우편번호기본주소
     * @type {string}
     */
    spaeZpcdBscAdr: '',

    /** 별도청구지우편번호상세주소
     * @type {string}
     */
    spaeZpcdDtlAdr: '',

    /** 별도청구지도로명주소구분코드
     * @type {string}
     */
    spaeRdndDcd: '',

    /** 별도청구지도로명기본주소
     * @type {string}
     */
    spaeRdnmBscAdr: '',
    /** 별도청구지도로명상세주소
     * @type {string}
     */
    spaeRdnmDtlAdr: '',

    /** 별도청구지건물관리번호
     * @type {string}
     */
    spaeBldnMngmNo: '',

    /** 별도청구지전화지역번호
     * @type {string}
     */
    spaeTelLln: '',

    /** 별도청구지전화국번호
     * @type {string}
     */
    spaeTelTon: '',

    /** 별도청구지전화개별번호
     * @type {string}
     */
    spaeTelIncsNo: '',

    /** 오류응답서비스ID
     * @type {string}
     */
    erorRspnSvcId: '',

    /** 에러대상메시지내용
     * @type {string}
     */
    errTgtMsgCon: '',

    /** 후불교통카드여부
     * @type {string}
     */
    ftpmTrcdYn2: '',

    /** 해외사용가능여부
     * @type {string}
     */
    ovrsUseAblYn2: '',

    /** 후불교통카드여부
     * @type {string}
     */
    ftpmTrcdYn3: '',

	/** 수수료수납여부
	 * @type {string}
	 */
	feeRcptYn: '',
	
	/** 출금의뢰금액
	 * @type {nubmer}
	 */
	drotReqsAmt: 0,
	
	/** 항공사카드여부
	 * @type {string}
	 */
	arliCardYn: '',
	
    /** PdfDtlList1[]
     * @type {PdfDtlList1[]}
     */
    pdfDtlList1: null,

    /** PdfDtlList2[]
     * @type {PdfDtlList2[]}
     */
    pdfDtlList2: null,

    /** PdfAddList1[]
     * @type {PdfAddList1[]}
     */
    pdfAddList1: null,

    /** PdfAddList2[]
     * @type {PdfAddList2[]}
     */
    pdfAddList2: null,

    /** PdfLnkList[]
     * @type {PdfLnkList[]}
     */
    pdfLnkList: null,

    /** RltdPdfList[]
     * @type {RltdPdfList[]}
     */
    rltdPdfList: null,

    /** PdtmInfoList[]
     * @type {PdtmInfoList[]}
     */
    pdtmInfoList: null,

    /** 학생증카드여부 ("Y" / "N")
     * @type {string}
     */
    sccYn: '',

    /** 국제학생증카드타입("N" / "ISIC")
     * @type {string}
     */
    innnSccType: '',
}
